import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../shared/utils/objects';
import { ChatAssistantFilter } from '../../../../shared/types/chat-assistant';
import { ISelect } from '../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetProjects } from '../../../../services/projects.service';

export const useChatAssistantFilters = (
    onFilter?: (data: ChatAssistantFilter) => void
) => {
    const [projects, setProjets] = useState<ISelect[]>([]);
    const onSubmit = (data: ChatAssistantFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetProjects().then((projects) =>
            setProjets(projects.items as ISelect[])
        );
    }, []);

    return {
        formik,
        projects,
    };
};
